<div class="users-main-page records-page">
    <div class="datatable-page-shell">
        <div class="records-page__hero users-main-hero">
            <div class="records-page__hero-primary">
                <div class="records-page__hero-headline">
                    <span class="records-page__hero-eyebrow">{{ 'USERS' | translate }}</span>
                    <h3 class="records-page__hero-title">{{ 'YOUR_USERS' | translate }}</h3>
                </div>
            </div>
            <div class="records-page__hero-aside">
                <div class="records-page__hero-actions">
                    <ng-select class="saved-search-select" [items]="userSavedSearches" bindLabel="name" bindValue="id"
                        [placeholder]="'SAVED_SEARCHES' | translate" [(ngModel)]="selectedSavedSearchId"
                        (ngModelChange)="onSavedSearchChange($event)" [clearable]="true">
                    </ng-select>
                    <button *ngIf="doWhat.isAdmin || doWhat.canCreate" type="button" class="blue-button" (click)="onAddNew()">{{ 'ADD_USER' | translate }}</button>
                </div>
            </div>
        </div>

        <div class="details-tab-surface users-main-surface datatable-page-surface">
            <app-campaign-datatable class="records-page__table" [iCanRead]="tablePermissions.canRead" [iCanWrite]="tablePermissions.canWrite" [iCanDelete]="tablePermissions.canDelete" [iColumns]="columns" [iShowExport]='false' [iSortColumn]="'lastName,firstName'"
                (oRowClick)="onClientRowClick($event)" [iActiveUserId]="activeUser?.id" (oDeleteRows)="deleteRows($event)" (oEditRow)="editRow($event)" (oArchiveRows)="archiveRows($event)" (oUnArchiveRows)="unarchiveRows($event)"
                [iData$]="usersData"></app-campaign-datatable>
        </div>
    </div>
</div>
